<style lang="scss" scoped>
  $leftWidth: 180px;
  .content-part {
    .content-left {
      width: $leftWidth;
    }

    .content-right {
      > h3 {
        left: $leftWidth;
      }

      left: $leftWidth;
    }
  }
  .cancel-reason {
    display: flex;
    align-items: center;
    margin: 5px;

    .el-select {
      width: 100%;
    }
  }
</style>

<template>
  <div>
    <div class="content-part">
      <div class="content-left">
        <h2 class="clearfix right-title">订单详情</h2>
        <ul>
          <li class="list-style" v-for="item in pageSets" @click="showPart(item)" :key="item.key"
              v-bind:class="{ 'active' : index===item.key}"><span>{{ item.name }}</span>
          </li>
          <div v-show="!isNeed">
            <perm label="bsp-order-org-confirm">
              <div class="text-center mt-10" v-show="currentOrder.status === '0' && type === 0">
                <el-button type="primary" @click="confirm">确认订单</el-button>
              </div>
              <div class="text-center mt-10" v-show="currentOrder.status === '0' && type === 1">
                <el-button type="primary" @click="audit">审单通过</el-button>
              </div>
            </perm>
            <perm label="bsp-order-org-cancel">
              <div class="text-center mt-10" v-show="currentOrder.status && !['1', '2', '5'].includes(currentOrder.status)">
                <el-button @click="showCancelButton = true">取消订单</el-button>
              </div>
            </perm>

            <perm label="bsp-order-org-transport">
              <div class="text-center mt-10" v-show="currentOrder.status === '1' && type === 1">
                <el-button @click="complete">完成订单</el-button>
              </div>
            </perm>
            <div  v-show="currentOrder.bizType === '1-4' && currentOrder.status === '1'">
              <perm :label="xmlBtnList[10].perm">
                <div class="text-center mt-10">
                  <el-button @click="xmlBtnList[10].click(currentOrder.id)" type="primary">{{xmlBtnList[10].label}}</el-button>
                </div>
              </perm>

              <perm :label="xmlBtnList[11].perm">
                <div class="text-center mt-10">
                  <el-button @click="xmlBtnList[11].click(currentOrder.id)" type="primary">{{xmlBtnList[11].label}}</el-button>
                </div>
              </perm>

            </div>
            <perm :label="xmlBtnList[13].perm">
              <div class="text-center mt-10" v-show="['2-0', '2-1'].includes(currentOrder.bizType) && ['1', '5'].includes(currentOrder.status)">
                <el-button @click="xmlBtnList[13].click(currentOrder.id)" type="primary">{{xmlBtnList[13].label}}</el-button>
              </div>
            </perm>
            <perm :label="xmlBtnList[14].perm">
              <div class="text-center mt-10" v-show="['1-0', '1-1'].includes(currentOrder.bizType) &&  ['1', '5'].includes(currentOrder.status)">
                <el-button @click="xmlBtnList[14].click(currentOrder.id)" type="primary">{{xmlBtnList[14].label}}</el-button>
              </div>
            </perm>

          </div>
        </ul>
      </div>
      <div class="content-right content-padding">
        <h3>{{ title }}</h3>
        <basic-info :currentOrder="currentOrder" :type="type" v-show="index === 0" :index="index"></basic-info>
        <log :currentOrder="currentOrder" v-show="index === 2" :isShow="index===2"></log>
        <receipt-detail :currentOrder="currentOrder" v-show="index === 3" :index="index"/>
        <push-org :order-id="currentOrder.id" :index="index" v-show="index === 4"/>
        <exception-info :currentOrder="currentOrder" :index="index" v-show="index === 5"/>
        <relevance-code :currentOrder="currentOrder" :index="index" v-show="index === 9"></relevance-code>

        <div class="comment-box" v-show="showCancelButton">
          <oms-row label="取消订单原因" :span="3" class="cancel-reason">
            <el-select type="text" v-model="cancelOrderIdea" placeholder="请选择取消订单原因">
              <el-option :value="item.label" :key="item.key" :label="item.label"
                         v-for="item in cancelOrderReasons"></el-option>
            </el-select>
          </oms-row>
          <div class="comment-box-submit">
            <el-button type="primary" @click="submitCancelOrder">提交取消订单原因</el-button>
            <el-button type="primary" @click="cancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import basicInfo from './base-info.vue';
  import log from './log.vue';
  import {BSPOrder} from '@/resources';
  import ReceiptDetail from './receipt-detail';
  import pushOrg from '@/components/order-push-log';
  import ExceptionInfo from './exception.info';
  import RelevanceCode from './relevance.code-review';

  export default {
    components: {basicInfo, log, ReceiptDetail, pushOrg, ExceptionInfo, RelevanceCode},
    props: {
      orderId: {
        type: String
      },
      defaultIndex: {
        type: Number
      }
    },
    data() {
      return {
        currentOrder: {},
        index: 0,
        title: '',
        showCancelButton: false,
        cancelOrderIdea: ''
      };
    },
    watch: {
      defaultIndex(val) {
        this.cancel();
        if (val !== 1) return;
        this.index = 0;
        this.title = '订单详情';
        this.queryOrderDetail();
      }
    },
    computed: {
      pageSets() {
        let menu = [];
        let perms = this.$store.state.permissions || [];
        menu.push({name: '订单详情', key: 0});
        if (['1', '4'].includes(this.currentOrder.status) && this.currentOrder.type === '0') {
          menu.push({name: '收货详情', key: 3});
        }
        menu.push({name: '异常信息', key: 5});
        menu.push({name: '订单日志', key: 2});
        menu.push({name: '推送日志', key: 4});
        menu.push({name: '复核追溯码', key: 9});
        return menu;
      },
      type() {
        return this.$route.meta.type;
      },
      cancelOrderReasons: function () {
        return this.$getDict('cancelOrderReason');
      },
      isNeed() {
        return this.$route.meta.isNeed;
      }
    },
    methods: {
      queryOrderDetail() {
        this.currentOrder = {};
        if (!this.orderId) return false;
        BSPOrder.get(this.orderId).then(res => {
          this.currentOrder = res.data;
        });
      },
      showPart(item) {
        this.index = item.key;
        this.title = item.name;
      },
      confirm() {
        this.$confirm('是否确认订单', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.put(`bsp-order/${this.currentOrder.id}/confirm`).then(() => {
            this.$notify({
              duration: 2000,
              message: '已经确认订单',
              type: 'success'
            });
            this.$emit('refresh');
          }).catch(error => {
            this.$notify({
              duration: 2000,
              title: '无法操作',
              message: error.response && error.response.data && error.response.data.msg || '网络异常',
              type: 'error'
            });
          });
        });
      },
      audit() {
        this.$confirm('是否审单通过', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.put(`bsp-order/${this.currentOrder.id}/confirm`).then(() => {
            this.$notify({
              duration: 2000,
              message: '审单通过',
              type: 'success'
            });
            this.$emit('refresh');
          }).catch(error => {
            this.$notify({
              duration: 2000,
              title: '无法操作',
              message: error.response && error.response.data && error.response.data.msg || '网络异常',
              type: 'error'
            });
          });
        });
      },
      complete () {
        this.$confirm('是否确认订单完成', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.put(`bsp-order/${this.currentOrder.id}/transport`).then(() => {
            this.$notify({
              duration: 2000,
              message: '订单完成',
              type: 'success'
            });
            this.$emit('refresh');
          }).catch(error => {
            this.$notify({
              duration: 2000,
              title: '无法操作',
              message: error.response && error.response.data && error.response.data.msg || '网络异常',
              type: 'error'
            });
          });
        });
      },
      cancel() {
        this.showCancelButton = false;
        this.cancelOrderIdea = '';
      },
      submitCancelOrder() {
        if(!this.cancelOrderIdea) return this.$notify.info('请选择取消原因');
        this.$http.put(`bsp-order/${this.currentOrder.id}/cancel`, {reason: this.cancelOrderIdea}).then(() => {
          this.$notify({
            duration: 2000,
            message: '取消成功',
            type: 'success'
          });
          this.$emit('refresh');
        }).catch(error => {
          this.$notify({
            duration: 2000,
            title: '无法操作',
            message: error.response && error.response.data && error.response.data.msg || '网络异常',
            type: 'error'
          });
        });
      }
    }
  };
</script>

